var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\u0428\u0430\u0440_1",
    "data-name": "\u0428\u0430\u0440 1",
    viewBox: "0 0 2121 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -97.91,
    y1: 181.56,
    x2: 883,
    y2: 181.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8992e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b98416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cda035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -97.91,
    y1: 491.68,
    x2: 883,
    y2: 491.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -97.91,
    y1: 444.92,
    x2: 883,
    y2: 444.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -97.91,
    y1: 395.41,
    x2: 883,
    y2: 395.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 841.6,
    y1: 421.52,
    x2: 2136.81,
    y2: 421.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 841.6,
    y1: 421.33,
    x2: 2136.81,
    y2: 421.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 841.6,
    y1: 422.4,
    x2: 2136.81,
    y2: 422.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 841.6,
    y1: 421.31,
    x2: 2136.81,
    y2: 421.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 841.6,
    y1: 421.58,
    x2: 2136.81,
    y2: 421.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 841.6,
    y1: 421.47,
    x2: 2136.81,
    y2: 421.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 841.6,
    y1: 421.8,
    x2: 2136.81,
    y2: 421.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 841.6,
    y1: 224.27,
    x2: 2136.81,
    y2: 224.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 841.6,
    y1: 224.42,
    x2: 2136.81,
    y2: 224.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 841.6,
    y1: 224.01,
    x2: 2136.81,
    y2: 224.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 841.6,
    y1: 223.78,
    x2: 2136.81,
    y2: 223.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 841.6,
    y1: 223.52,
    x2: 2136.81,
    y2: 223.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 841.6,
    y1: 224.06,
    x2: 2136.81,
    y2: 224.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 841.6,
    y1: 223.2,
    x2: 2136.81,
    y2: 223.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 841.6,
    y1: 224.58,
    x2: 2136.81,
    y2: 224.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 841.6,
    y1: 224.48,
    x2: 2136.81,
    y2: 224.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 841.6,
    y1: 223.87,
    x2: 2136.81,
    y2: 223.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 841.6,
    y1: 223.97,
    x2: 2136.81,
    y2: 223.97,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.17.7c-1.45,4.52-2.89,8.68-4.13,12.9-8,27.33-16.15,54.64-23.93,82-1.64,5.77-4.58,9-10.28,11.31-25.15,10-50.1,20.54-77.35,31.8,4.43.38,6.72.74,9,.75,18.62,0,37.24.22,55.84-.17,7.56-.15,10,3.15,8.65,9.88-2.67,13.66-5.34,27.34-8.59,40.87-.59,2.44-3.59,5-6.1,6.15-10.85,5-21.93,9.5-32.89,16.1,7.69,0,15.37,0,23.05,0,11.52,0,11.78.81,10.87,12.49-3.05,39-5.78,78.05-8.61,117.07a34.88,34.88,0,0,0,.24,4.37c13.19-3.93,26-8.79,39.3-11.5,26.75-5.45,52.77-1.57,78,8.62,27.85,11.23,55.88,12,83.94.57,1.31-.54,2.85-1.43,4-1.15a74.2,74.2,0,0,1,8.47,3c-1.51,2.28-2.5,5.67-4.62,6.68a109.52,109.52,0,0,1-65.21,9.19,177.25,177.25,0,0,1-36.14-9.92c-31-12-61.77-11.39-91.93,1-34.56,14.25-68.27,12.61-102.27-1.06-29.73-12-59.61-11.53-89.13.61-33,13.59-66.11,14.56-99.16,1-31-12.72-61.71-14.06-93-1.42-35,14.12-69.86,14.21-105.06-.54-28.33-11.87-57.35-11.52-86.31-.93-2.92,1.07-9.09.41-9.9-1.28-2.31-4.85,2.14-6.3,6.19-7.85,33.87-12.92,67.21-10.55,100.4,2.62,26.82,10.64,54,11.5,81.08,1.18a18.48,18.48,0,0,0,9.41-8.54c27.22-59.38,62.48-113.29,107.19-161.08C355.4,119.73,415.62,75,484.46,42A546.77,546.77,0,0,1,602,1C611.21-1.06,621.26.7,632.17.7ZM206.7,336.49c3.85,0,5,.23,6.08,0,28.95-7.19,57-4.36,84.58,6.69,29.25,11.71,58.6,12.05,88.08-.14A139,139,0,0,1,443,332.52c20.19.54,38.4,7.41,57.09,13.48,16.65,5.41,33.82,8,51.24,4,2.13-.48,5-3.77,5.16-5.9,2.43-40,4.5-80.11,6.68-120.87-15.36,0-32.22.25-49.06-.24-3-.08-5.82-3.29-8.72-5.06,2.16-2.26,3.9-5.49,6.54-6.63,17.77-7.73,35.75-15,53.59-22.5,2.17-.92,5.22-2.51,5.67-4.33,2.65-10.72,4.66-21.6,7.1-33.48H567.89c-25.49,0-51,.1-76.45-.3-3.39-.06-6.74-2.86-10.11-4.38,2.43-2.71,4.33-6.65,7.37-7.92,31.54-13.22,63.24-26.08,95-38.86,6-2.39,9.59-5.64,11.22-12.43,3.82-15.8,8.72-31.34,13.26-47,3-10.18,6.05-20.34,9.67-32.5C428.66,53.68,293,162.67,206.7,336.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M685.19,489.73c-1.19,7.93-4.69,8.45-9.61,6.58-15-5.69-30.54-10.16-46.66-8.28-13.75,1.61-28,3.37-40.75,8.34-34.72,13.52-69,14.76-103.55.8-27.19-11-54.69-13-82.81-4-13,4.14-25.9,9.12-39.22,12-27,5.76-52.76-.4-77.94-10.27-25.47-10-51.06-9.35-77.08-1.34-17.38,5.35-35.07,10.58-53,13.06-20.76,2.87-40.85-3.27-60.2-10.86-27.47-10.79-55-11.38-82.81-1.2-1.61.59-3.33,1.69-4.86,1.5-2.73-.35-5.37-1.5-8-2.32,1.66-2.47,2.78-6.31,5.07-7.22,30.15-12,61.07-13.88,91.18-1.47,36.21,14.93,71.16,14.51,107.25-.41,27.06-11.17,55.57-11.31,83-.71,28.44,11,57,16.92,87,8.56,13.69-3.82,26.83-9.77,40.63-13,26.47-6.24,52.12-1.91,77.18,8.15,30.25,12.15,60.69,11.82,90.91-.56,31.14-12.76,62.6-14.25,94.36-2.49C679,485.85,682.28,488.17,685.19,489.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M534.14,461.62c-17-4.33-34.57-7.22-51-13.35-29.66-11.1-59-12.59-88.2-.58-36.38,14.95-72,14.52-108.3-.48-28.66-11.84-57.92-10.87-86.69.85-32.36,13.17-65,14.79-97.76,1.95-3-1.16-7.28-5.89-6.73-7.6,1.87-5.81,6.7-3.06,10.65-1.6,29.45,10.87,58.6,10.25,87.69-1.71,33.55-13.79,67.29-14.19,101-.22,26.88,11.16,54.27,12.33,82.06,4.14,13.64-4,26.89-9.69,40.74-12.53,22.6-4.64,45-2,66.46,6.78,31,12.72,62.23,15.41,93.92,2.51,3.83-1.56,8.69-2.51,9.71,2.73.41,2.13-3.4,6.77-6.05,7.5C566.35,454.24,550.82,457.64,534.14,461.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.83,410.82c-21.33.27-39.08-4.83-56.53-11.67-27.76-10.89-55.69-11.39-83.64-.56-1.07.41-2.28,1.23-3.22,1-2.93-.7-5.76-1.81-8.63-2.76,1.64-2.26,2.79-5.71,5-6.61,20.78-8.55,42.45-11.9,64.69-8.15,10.92,1.84,22,4.25,32.22,8.41,32.73,13.36,64.84,12.43,97.31-.83,31.38-12.81,63.33-12.62,94.57.06,33.57,13.62,66.11,13.18,99.65-.66,30.23-12.48,61.47-11.61,92.26-.37,3.94,1.44,9.4,3,6.61,8.54-1,1.88-7,2.83-9.92,1.82-29.45-10.27-58.58-10.89-87.63,1.31-37,15.52-73.27,12.74-109.94-2.24-25.48-10.41-52-9.65-77.88,0C380.2,405,361.61,411.4,343.83,410.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1244,508.9c1.09-3.59,1.07-7.28,2.88-8.83,9.24-7.93,9.2-18.46,9.2-29.09,0-32.49-.15-65,0-97.46.05-10.49-1.27-20.07-9.38-27.92-2.25-2.18-2.61-6.33-4.51-11.35,14,0,26.1-.63,38,.43,3.09.28,6.79,5.36,8.38,9,18.44,42.47,36.52,85.1,54.74,127.66a48.86,48.86,0,0,0,3.11,5c11.44-26.75,22.31-52.15,33.16-77.57,8.27-19.38,16.38-38.82,24.9-58.08,1.18-2.66,4.24-6.23,6.58-6.34,12.7-.62,25.45-.3,40.44-.3-2.3,5-2.94,8.55-5,10.61-8.49,8.38-10.28,18.37-10.1,29.88.52,33.24.36,66.48,0,99.72-.08,9.13,1.41,16.91,8.46,23.46,2.58,2.4,3.38,6.7,5.53,11.28h-57.72c1.83-4.07,2.44-7.6,4.52-9.65,7.87-7.76,10-17,9.94-27.74-.36-35.5-.13-71-1.63-107-8.58,19.66-17.25,39.29-25.73,59-8.76,20.38-17.15,40.92-26.26,61.14-1.32,2.93-5.61,6-8.8,6.35-20.26,2.07-20.44,1.88-28.41-16.23-15.27-34.72-30.34-69.52-47.21-104.1,2.35,45.85-8.62,92.05,5.85,138.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1132.25,511.93c-53.78,2-95.36-40.93-95.13-89.41.24-52.15,41.33-91.69,96.07-91.86,51.85-.15,95.1,41.1,94.69,91S1186.91,513.67,1132.25,511.93Zm65.65-74.15c-1.91-31.77-13.17-60.49-40-81.38-17.85-13.9-38.15-19-59.45-9.47-19.77,8.83-26.67,26.93-27.82,47.15-1.74,30.58,7.22,58.27,26.27,82.1,20.6,25.76,51.08,33.09,74.08,18.55C1191.36,481.86,1196.45,461.34,1197.9,437.78Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1933.5,486.84V420.38q0-18.13,0-36.26c0-8.31,1-16.79-.33-24.89-1.28-7.82-5-15.26-8-24h31.65c-1,3.31-1,6.48-2.56,7.9-9.23,8.33-9.37,19.09-9.33,30.24.14,40.8,0,81.6,0,122.39v12c-22.22,5.61-26.83,3.58-37.88-13.66q-42.75-66.75-86-133.2c-.78-1.21-1.94-2.17-4.37-3,2.75,50.17-7,100.67,5.11,151.09H1792c1.34-3.79,2.48-6.74,3.43-9.76,2.94-9.42,8-18.79,8.3-28.31,1.06-31.32.18-62.7.5-94.05.12-12.08-1-23.29-10.22-32.36-1.87-1.83-2.27-5.16-4.27-10,14.53,0,27.19-.53,39.74.39,3,.22,6.26,4.9,8.39,8.19q43,66.56,85.63,133.3c2.42,3.77,4.93,7.48,7.4,11.22Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1020.92,379.94c-10.51,0-20,.64-29.3-.31-3.79-.39-8-3.58-10.71-6.63-12.3-13.68-25.53-25.62-44.4-29.36-26.54-5.27-49.12,8.66-56.25,34.86-10.66,39.22,9.89,92.91,43.93,114.78,25.17,16.16,58.9,8,71.21-19.64,6-13.53,13.57-14.69,25.18-12.06-6.69,26-47.53,51.82-83.63,49.42-53.7-3.56-89.38-38.23-92-87.81-2.16-41.85,30.82-80.69,76-89.51C966.88,324.74,1008.55,343.42,1020.92,379.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1782.32,509.31h-53.39c.52-3.09,0-6.83,1.57-8.16,8.49-7.24,6-15.45,2.94-23.81-8.26-22.3-8.3-22.29-32.21-22.28-17,0-34-.39-51,.37-3.67.17-8.07,3.88-10.46,7.17-2.78,3.82-3.48,9.08-5.48,13.54-4,8.82-7.4,17.45-.25,26.46.91,1.14.13,3.62.13,6.29h-31.53c.84-3.05.72-6.6,2.42-8.15,15.92-14.5,19.8-35.05,27.29-53.68,13.88-34.53,27.59-69.14,40.48-104,4.68-12.69,14.27-7.82,22.47-9,7.76-1.09,11.26,2.66,14,9.66,17.88,45.87,36,91.65,54.59,137.21,2.4,5.89,8.3,10.35,12.58,15.47l8.44,10.14ZM1683.65,351l-36.21,91.87H1720Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1508.14,441.8c-3.52,24.7-1.39,46.57,14.37,67.27h-57.74c1.3-4.24,2.41-7.61,3.37-11,3.1-11,8.32-21.92,8.8-33,1.26-28.64,1.3-57.42,0-86.05-.54-11.47-6-22.71-9.18-34.06-.86-3-1.8-6-3.29-11H1492c16.62,0,33.25-.13,49.86.1,32,.45,56.18,23.23,55.93,53.13-.19,23.48-15.92,53.52-54.57,54.62C1531.58,442.08,1520,441.8,1508.14,441.8Zm-.57-11c12,0,23.27.88,34.39-.2,19.25-1.87,34.36-16.91,37.3-35.52a44,44,0,0,0-23.88-46.72c-15.35-7.83-31.4-4.29-47.81-4.61Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1962,334.89h51.76c.62,1.07,1.45,1.95,1.27,2.27-8.57,15.36.21,26.9,8,39,9.57,14.79,18.42,30,28.41,46.47,14.63-21.57,29.33-41.51,41.78-62.77,3.34-5.69-.17-15.39-.59-24.31h30c-1.69,3.28-2.64,5.89-4.21,8.06q-30.24,41.94-60.64,83.78c-1.83,23.55-5.89,47.32,7.21,69.34,2,3.33,3.65,6.85,6.36,12h-56.6c1.3-3.76,2.56-7.18,3.68-10.65,3.48-10.86,8.24-21.51,10.09-32.64,4.21-25.38-2.38-48.05-19.09-68.17-7.64-9.21-12.45-20.72-19.63-30.38-5.93-8-13.5-14.75-20.24-22.15C1967.55,342.47,1965.85,339.89,1962,334.89Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1713.65,281.74h-38.4c12.91-38.37,12.64-76.19.5-114.94h32.46c-2.71,17.82-5.3,34.88-8.11,53.37h51.08c0-17.53,4.5-35.63-11-53h40.42c-13.28,17.78-10.22,37.54-9.84,56.73.38,18.91-4.83,38.81,11.48,57.25h-36.67c2.67-16.18,5.34-32.34,8.25-50h-50.62C1701.27,248,1700.33,264.59,1713.65,281.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1201.8,280.47c9.41-37.63,9.81-74.92-.47-114.15,28,.65,57.51-6.59,83,15,28.52,24.17,24.13,72.29-8.87,91.94C1260,282.42,1219,286.22,1201.8,280.47Zm26.83-107.85v102c19.24,3.75,34.69-.66,44.43-17.56,12.9-22.38,13-45.14-.83-67.2C1262.27,173.89,1247,169.78,1228.63,172.62Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1101.26,223.76c0,33.56-27.12,59.8-62,60.07-35.51.27-63.56-26.42-63.2-60.14.36-33.29,27.75-59.24,62.79-59.5C1073.19,163.94,1101.28,190.73,1101.26,223.76Zm-20,12.39c-.93-25.09-9.75-44.64-30-57.93C1028,163,1000.74,175,999,202.58c-.87,13.29,2.18,27.74,7.13,40.2,4.1,10.32,12.34,20,21,27.23,10.4,8.67,23.68,9.4,36.09,2.48C1078,264.25,1080.56,249.86,1081.28,236.15Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M943.46,239.92l-15.36-7.31c4.88-1.36,9.69-3.37,14.67-3.91,6.24-.69,12.62-.17,19.65-.17V276c-14.07,2.05-27.22,3.23-40,6-29.47,6.33-59.34-7.07-71.5-32.9-12.6-26.74-4.76-55,20.48-73.93,24.54-18.39,67.76-13.1,85.13,10.52,2.1,2.87,3.57,6.2,5.81,10.16-13.4,1.81-24.43,3.24-32.37-9.3-3-4.74-9.08-7.94-14.34-10.76-21.62-11.57-45.22.11-48.26,24.57-3.39,27.3,5.11,51.15,26.76,68.47,6.41,5.13,16.81,8.19,25,7.55C936.69,274.94,948.5,266.41,943.46,239.92Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1964.68,236.67l38.8,43.69h-30.81c-.48-18.25-22-43.58-38.74-41.71,2.26,13.94,4.5,27.73,6.87,42.3h-32.28c14.78-26,5.75-53.75,7.47-80.46.67-10.44-2.92-21.15-4.82-33.39a51.86,51.86,0,0,1,7.8-.93c12.47-.13,25-.07,37.43,0,20.74.16,34.4,10.38,38.22,28.48,3.54,16.75-5.55,32.08-23.8,40.09C1969.45,235.36,1968,235.67,1964.68,236.67Zm-28.39-6.55c16.42.77,32.72,2.95,42.93-13.23,6.58-10.42,6.31-21.75-.9-31.94-10.56-14.89-26-13.83-42-12.18Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1499.15,262.74c-1.65-31.53,3.2-63.29-3.68-96h19.08c-13.18,34.31-4.16,69.48-7,103.88-.33,4-1.85,10.85-3.76,11.19-6.57,1.18-14,3.28-19.08-4.94-13.66-22.13-27.84-44-41.89-65.85-5.57-8.67-11.36-17.2-17.26-26.12v96.31h-19c2.44-5.52,6.5-10.56,6.64-15.71.73-26.8.67-53.63.3-80.44,0-3.68-3.15-7.43-5.22-10.93-3.35-5.69-1.86-8,4.66-8.72,12.87-1.36,22,1.12,29.53,14.08,16.66,28.63,35.72,55.86,53.81,83.66Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2058.54,211.33c6.85,5.74,13,9.65,17.56,14.95,15.08,17.56,29.58,35.63,44.9,54.24h-34.92c7.23-10.87,1.5-17.83-4.94-25.27-10.09-11.67-19.42-24-29-35.94-17.34,8.36-19.8,34.39-5.27,61.1h-35c15.41-31.3,5.08-64.35,7.24-96.36.33-4.8-5.29-10-9-16.55h38.27c-15,14.84-8.73,31.54-10.28,50.47,7.93-5.74,14.2-9.11,19-14,12.22-12.4,30.33-18.1,38.59-35.54,1.53-3.22,13.1-1.69,22.46-2.58Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1341.54,221.15c6,0,11.26-.51,16.36.22,2.55.36,4.77,3,7.14,4.58-2.23,1.39-4.36,3.72-6.72,4-5.18.61-10.47.19-16.74.19v41.63c20.38,6.25,35.85-8.44,54.34-12.63.32,4,.64,6.23.65,8.42.06,15,0,15-14.72,15H1314.7c9.6-39,10.26-77-.39-116h81.53v21.77l-54.3-17.21Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1580.84,254.26c4.12,2.19,9.34,3.45,12.18,6.74,11.84,13.73,26.74,14.54,42.45,10.61,12.79-3.21,16-13.2,6.91-22.88-6.81-7.25-15.58-12.77-23.91-18.43-9.32-6.34-19.8-11.1-28.55-18.09-12.69-10.13-12.21-24-.15-34.94,14.44-13.07,48.68-16,63.92-4.36,3.28,2.52,2.92,9.78,4.17,14.61-9.44,5.11-13.2-.93-17.59-5.27-9.71-9.61-21.18-11.7-31.65-5.77-10.28,5.83-11.58,14.5-2.15,21.44s19.82,12.14,29.6,18.43c6.3,4.05,12.8,8.08,18.22,13.18,17.22,16.2,13.48,39.3-8.39,48.56-20.65,8.74-41.79,5.85-61.46-3.32-4.33-2-5.34-11.13-7.88-17Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1903.71,281.24h-35.56c1.29-5.73,4-11.12,3.34-16.07-2.08-15.59-6.88-19.09-22.69-19.08l-21.54,0c-19.53,0-27.88,11.39-22.77,30.9.26,1,0,2.16,0,4.29h-17.74c14.82-36.81,29.25-73.34,44.54-109.5,1.34-3.16,8.27-5.26,12.67-5.39,3.33-.1,8.63,3,9.88,6,11.9,28.51,22.79,57.44,34.77,85.91C1891.84,265.89,1897.77,272.36,1903.71,281.24Zm-66.22-104.19c-8.19,21.63-15.51,41-23,60.65h46.25C1853,217.36,1845.62,198.23,1837.49,177.05Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1113,166.92h34.71c-15.06,31.09-5.79,63.1-8.35,94.21-.31,3.68,0,7.4,0,14.28l54.42-7.27V281H1112.8C1123.85,242.7,1123.54,205.62,1113,166.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolden);
export default __webpack_public_path__ + "static/media/golden.bbd2c93592e0a8542e7fc214338b0013.svg";
export { ForwardRef as ReactComponent };